import * as R from 'ramda'
import { Base64 } from 'js-base64'

import { getBaseFilterFeedbackOptions } from 'hooks/useFilterOptions/constants'
import { languageOption } from 'organisms/FeedbackFilterGroup/constants'

const baseFilterFeedbackOptions = getBaseFilterFeedbackOptions()

export function generateFeedbackFilterParam(rules) {
  const filters = {
    condition: 'and',
    rules: rules,
  }

  const searchParameters = JSON.stringify(filters)
  const queryString = Base64.encodeURI(searchParameters)

  return `?filter=${queryString}`
}

export function createSurveyfilterRule(surveyToken, surveyName) {
  const rule = R.omit(
    ['inputComponent'],
    R.find(R.propEq('field', 'survey'))(baseFilterFeedbackOptions)
  )
  rule['filters'] = [
    {
      value: surveyToken,
      label: surveyName,
    },
  ]
  return rule
}

export function createSentimentfilterRule(sentiment) {
  const sentimentLabel = {
    positive: 'Positive',
    neutral: 'Neutral',
    negative: 'Negative',
  }

  const rule = R.omit(
    ['inputComponent'],
    R.find(R.propEq('field', 'sentiment'))(baseFilterFeedbackOptions)
  )
  rule['filters'] = [
    {
      value: sentiment,
      label: sentimentLabel[sentiment],
    },
  ]
  return rule
}

export function createTeamMemberfilterRule(identifier, name) {
  const rule = R.omit(
    ['inputComponent'],
    R.find(R.propEq('field', 'team_member'))(baseFilterFeedbackOptions)
  )
  rule['filters'] = [
    {
      value: identifier,
      label: name,
    },
  ]
  return rule
}

export function createShowCommentFilterRule() {
  const rule = R.omit(
    ['inputComponent'],
    R.find(R.propEq('field', 'only_show_comment'))(baseFilterFeedbackOptions)
  )
  return rule
}

export function createCompanyFilterRule(company) {
  const rule = R.omit(
    ['inputComponent'],
    R.find(R.propEq('field', 'company'))(baseFilterFeedbackOptions)
  )
  rule['filters'] = [
    {
      value: company,
      label: company,
    },
  ]
  return rule
}

export function getLanguageLabelByCode(code) {
  return Object.keys(languageOption).find((key) => languageOption[key] === code)
}

export function getLanguageCodeByLabel(label) {
  return languageOption[label]
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/FeedbackFilterGroup/utils.js